import React from "react";
import { Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import {readableDate} from "../../../utils";


class PrintInsuranceDetails extends React.Component{




    render(){
        let data = this.props.rental;
        let vehicleMake = (data.vehicle && data.vehicle.make) ? data.vehicle.make.name : "";
        let vehicleModal = (data.vehicle && data.vehicle.model) ? data.vehicle.model.name : "";
        let vehicleReg = data.vehicle ? data.vehicle.registration : "";
        let customerAddress = data.customer && (data.customer.address_line1 + " " + data.customer.town);
        let customerMobile = (data.customer && data.customer.company_phone_type === "Mobile") ? (data.customer.company_phone_country_code + data.customer.company_phone) : "";
        let customerLandLine = (data.customer && data.customer.company_phone_type === "Phone") ? (data.customer.company_phone_area_code +" "+ data.customer.company_phone) : "";
        let depValue = (data && data.vehicle && data.vehicle.finance_agreements && data.vehicle.finance_agreements[0]) ? (Math.round((data.vehicle.finance_agreements[0].estimated_value * 100))) / 100 : 0;

        let rentalType = () => {
            if(data.rental_type === "FOC"){
                return "FREE OF CHARGE"
            }
            else if(data.rental_type === "ST"){
                return "SHORT TERM"
            }
            else{
                return "LONG TERM"
            }
        }


        let getDepartmentDetails = (department) => {
            let returnData = {
                name: "",
                contactInfo: "TEL: "
            }
            // Handle not getting a department
            if(!(!!department)){
                return returnData
            }

            returnData.name = returnData.name + department.name + " JCR UNITS, CHERRY TREE ROAD, TIBENHAM, NORFOLK, NR16 1PH"
            if(department.id === 4){
                returnData.contactInfo = returnData.contactInfo + "01953 528601 EMAIL: info@direct-vanhire.co.uk"
            }
            else if(department.id === 5){
                returnData.contactInfo = returnData.contactInfo + "01953 528800"
            }
            else if(department.id === 6){
                returnData.contactInfo = returnData.contactInfo + "01953 528600"
            }
            else if(department.id === 7){
                returnData.contactInfo = returnData.contactInfo + "01953 528 900"
            }

            return returnData;
        }

        let contactInformation = getDepartmentDetails(data.department);

        // Using an array so i have line numbers and can just map through it
        let insuranceConfirmation = [
            {text: "To Whom it may concern", className:"out-border-top-black out-border-middle-black bold"},
            {text: "I am writing to confirm to you that the motor insurance with your company, under the certificate attached", className: "out-border-middle-black bold"},
            {text: "for vehicle registration number "+vehicleReg+" is currently active and in force", className: "out-border-middle-black bold"},
            {text: "The level of cover in place is Fully Comprehensive.", className: "out-border-middle-black bold"},
            {text: "If you believe any of the above to be incorrect please contact us immediately", className: "out-border-middle-black bold"},
            {text: "", className: "out-border-middle-black"},
            {text: "Kind Regards", className: "out-border-middle-black bold center"},
            {text: "Lee Osborne", className: "out-border-middle-black bold center"},
            {text: contactInformation.contactInfo, className: "out-border-middle-black out-border-bottom-black bold center"}
        ]


        return (
            <div>
                <Columns isMultiline>
                    <Column>
                        <Table isFullwidth isBordered>
                            <tbody>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold border-black"}><Title>INSURANCE COPY</Title></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold border-black"}>{contactInformation.name}</td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"table-header-bold border-black"}>{contactInformation.contactInfo}</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold border-black"}>{`RENTAL ${rentalType()} HIRE - RENTAL AGREEMENT`}</td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className={"table-header-bold fill-black border-black"}>VEHICLE DETAILS</td>
                                    <td colSpan={6} className={"table-header-bold fill-black border-black"}>INSURER OF VEHICLE</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>REGISTRATION:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{data.vehicle ? data.vehicle.registration : ""}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>NAME:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{data.customer ? data.customer.display_name : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>MAKE/MODEL:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{vehicleMake+"/"+vehicleModal}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>COMPANY:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{(data && data.customer) && data.customer.company_name}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>RETAIL VALUE:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>£{depValue}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>ADDRESS:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{customerAddress}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>POLICY NAME:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{data.policy_name}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}></td>
                                    <td colSpan={4} className={"wide-column border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>INSURER:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{data.insurer}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}></td>
                                    <td colSpan={4} className={"wide-column border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>POLICY NUMBER:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{data.policy_number}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>POSTCODE:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{data.customer ? data.customer.postcode : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>START DATE:</td>
                                    <td colSpan={4} className={"wide-column border-black"}></td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>MOBILE</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{customerMobile}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>EXPIRY DATE:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{readableDate(data.insurance_expiry)}</td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>LANDLINE:</td>
                                    <td colSpan={4} className={"wide-column border-black"}>{customerLandLine}</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-black border-black table-header-bold"}>CUSTOMER'S PERMISSIONS (TO BE TICKED BUY CUSTOMER)</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black"}></td>
                                    <td colSpan={10} className={"fill-grey border-black bold"}>ALL LONG TERM HIRE CUSTOMERS ARE REQUIRED TO INSURE VEHICLES THEMSELVES</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black"}></td>
                                    <td colSpan={1} className={"border-black"}></td>
                                    <td colSpan={9} className={"fill-grey border-black bold"}>{`I HEREBY GIVE FULL PERMISSION FOR ${data.department ? data.department.name : ""} & EVERYWHEN INSURANCE BROKERS TO ACCESS MY INSURANCE POLICY, ASSOCIATED DETAILS AND CLAIMS ON MY BEHALF`}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>ALL LONG TERM HIRE CUSTOMERS:</td>
                                    <td colSpan={1} className={"border-black"}></td>
                                    <td colSpan={9} className={"fill-grey border-black bold"}>{`I HEREBY GIVE FULL PERMISSION FOR ${data.department ? data.department.name : ""} & EVERYWHEN INSURANCE BROKERS TO CONTACT MY INSURANCE COMPANY TO CONFIRM INSURANCE IS IN PLACE FOR THIS VEHICLE`}</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-black border-black table-header-bold"}>CUSTOMER INSURANCE CONTACT DETAILS: (TO BE COMPLETED BY CUSTOMER)</td>
                                </tr>
                                <tr>
                                    <td colSpan={3} className={"fill-grey border-black bold"}>INSURANCE CONTACT NAME:</td>
                                    <td colSpan={3} className={"border-black"}></td>
                                    <td colSpan={3} className={"fill-grey border-black bold"}>INSURANCE PHONE NUMBER:</td>
                                    <td colSpan={3} className={"border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={3} className={"fill-grey border-black bold"}>INSURANCE EMAIL ADDRESS:</td>
                                    <td colSpan={6} className={"border-black"}></td>
                                    <td colSpan={3} className={"fill-grey border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-black border-black table-header-bold"}>CUSTOMER SIGNATURE TO GIVE AUTHORISATION</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>CUSTOMER NAME:</td>
                                    <td colSpan={4} className={"border-black"}></td>
                                    <td colSpan={2} className={"fill-grey border-black bold"}>SIGNED BY THE CUSTOMER TO GIVE PERMISSION:</td>
                                    <td colSpan={4} className={"border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"fill-black border-black table-header-bold"}>INSURANCE COMPANY CONFIRMATION:</td>
                                </tr>
                                {insuranceConfirmation.map(line => (
                                    <tr>
                                        <td colSpan={12} className={line.className}>{line.text}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>FLEET NUMBER</td>
                                    <td colSpan={2} className={"wide-column border-black"}>{data.vehicle ? data.vehicle.fleet_number : ""}</td>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>EMAIL SENT:</td>
                                    <td colSpan={1} className={"border-black"}></td>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>DATE SENT</td>
                                    <td colSpan={1} className={"wide-column border-black"}></td>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>EMAIL REPLY:</td>
                                    <td colSpan={1} className={"border-black"}></td>
                                    <td colSpan={1} className={"fill-grey border-black bold"}>DATE REPLIED:</td>
                                    <td colSpan={2} className={"wide-column border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold border-black"}><Title>INSURANCE COPY</Title></td>
                                </tr>
                            </tbody>
                        </Table>
                    </Column>
                </Columns>
            </div>
        );


    }

}

export default PrintInsuranceDetails;